import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FirGtapsCommonTemplateService {
  constructor(private http: HttpClient) {}

  private postLoad(baseUrl: string, actionCode: string, params: any, processName?: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=${actionCode}`;
    const body = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value !== undefined && value !== null) body.set(key, String(value));
    });
    if (processName) body.set('process_name', processName);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, body.toString(), { headers, withCredentials: true });
  }

  getPtiSummary(baseUrl: string, params: any): Observable<any> {
    return this.postLoad(baseUrl, 'vz4pf4', params, "GTAPS Get CFC's with Recapture Accounts");
  }
  getPtepSummary(baseUrl: string, params: any): Observable<any> {
    return this.postLoad(baseUrl, '8m6hpz', params);
  }
}
